import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function DeleteAccount() {
  const { user } = useAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  if (user.role === "admin") return null;

  const del = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      await api.post("/auth/delete-account", { password: pw });
      localStorage.removeItem("isoldit_token");
      window.location.replace("/");
    } catch (e2) { setErr(formatErr(e2)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="delete-account-section" className="mt-6 max-w-xl rounded-2xl border border-red-500/30 p-6">
      <p className="font-semibold text-red-300">Delete my account</p>
      <p className="mt-1 text-sm text-slate-400">Permanently deletes your profile, all listings, messages, ratings, saved items and saved searches. This can't be undone.</p>
      <Dialog>
        <DialogTrigger data-testid="delete-account-btn" className="mt-4 inline-flex items-center gap-2 rounded-xl bg-red-500 px-4 py-2.5 text-sm font-bold text-white hover:bg-red-600"><Trash2 className="h-4 w-4" />Delete my account</DialogTrigger>
        <DialogContent data-testid="delete-account-dialog" className="border-white/10 bg-[#173742] text-white">
          <DialogHeader>
            <DialogTitle className="font-display">Delete your account forever?</DialogTitle>
            <DialogDescription className="text-slate-400">Everything linked to {user.email} will be removed. Type DELETE and enter your password to confirm.</DialogDescription>
          </DialogHeader>
          <form onSubmit={del} className="space-y-3">
            <input data-testid="delete-account-confirm-input" className="field" placeholder="Type DELETE" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            <input data-testid="delete-account-password-input" type="password" className="field" placeholder="Your password" value={pw} onChange={(e) => setPw(e.target.value)} />
            {err && <p data-testid="delete-account-error" className="rounded-lg bg-red-500/15 px-3 py-2 text-sm text-red-300">{err}</p>}
            <button data-testid="delete-account-confirm-btn" disabled={confirm !== "DELETE" || !pw || busy} className="w-full rounded-xl bg-red-500 py-3 text-sm font-bold hover:bg-red-600 disabled:opacity-50">{busy ? "Deleting…" : "Permanently delete my account"}</button>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
